export default __webpack_public_path__ + "static/media/logo__technology__sass.6251c408.png";